import { Routes, Route, Navigate } from 'react-router-dom';
import ThemesList from './ThemesList';
import DetailsSettingRequest from 'components/SettingRequest/DetailsSettingRequest';

const Themes = () => {
  return (
    <Routes>
      <Route
        path=":settingRequestId/details"
        element={<DetailsSettingRequest />}
      />
      <Route path=":themeId" element={<Navigate relative="path" to=".." />} />
      <Route index element={<ThemesList />} />
    </Routes>
  );
};

export default Themes;
